export default "__VITE_ASSET__D$$YgKIi__"